import PropTypes from 'prop-types'

import Button from '../../../../../shared_components/mui_base_components/button/Button'

import './addDeputySection.scss'

const AddDeputySection = ({openAddDeputyModal}) => (
  <div className='add-deputy-section'>
    <Button className='invite' onClick={openAddDeputyModal}>
      Invite someone
    </Button>
  </div>
)

AddDeputySection.propTypes = {openAddDeputyModal: PropTypes.func.isRequired}

export default AddDeputySection
